import { useQuery } from "@tanstack/react-query";
import { getJobTitle } from "../../api/apiJobTitles";
import i18next from "i18next";

export function useGetJobTitle(id) {
    const { isLoading, data: jobTitle, error } = useQuery({
        queryKey: ["jobTitles", id, i18next.language],
        queryFn: () => getJobTitle(id),
        enabled: !!id,
        retry: false,
    });

    return { isLoading, error, jobTitle };
}
